module.exports = __webpack_public_path__ + "img/toggle_menu-ar.1dc8802f.png";